import React from 'react';
import PropTypes from 'prop-types';
import BodyWrapper from '@redturtle/iovisit-theme/components/Blocks/CTABlock/BodyWrapper';

import Block from '@redturtle/iovisit-theme/components/Blocks/CTABlock/Block';

const View = ({ data, id }) => {
  return (
    <BodyWrapper inEditMode={false}>
      <Block data={data} inEditMode={false} block={id} />
    </BodyWrapper>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
